const items = (count: number): string => `${count} item${count === 1 ? '' : 's'}`;

/** The disclosure count for a SMRiQ visit. Declined operations are NOT in the plan, so they
 *  are never folded into an "included" total; they are named separately or alone. */
export const smriqInclusionsLabel = (includedCount: number, declinedCount: number): string => {
    if (declinedCount === 0) return `${items(includedCount)} included`;
    if (includedCount === 0) return `${items(declinedCount)} declined`;

    return `${includedCount} included, ${declinedCount} declined`;
};
